<template>
  <div>
    <c-import-base
      :importFileService="segmentService"
      :csvProperties="csvProperties"
      :pageTitle="`${$t('ctx.import.segmentation__title')}`"
      :uploadButtonLabel="`${$t('ctx.import.segmentation__description')}`"
      help-link="https://support.invivodigitalfactory.com/hc/articles/15890399672604"
    >
      <c-import-information
        :title="`${$t('ctx.import.segmentation__informations')}`"
        :nbResultText="`${$t('ctx.import.segmentation__count')} : `"
        :exportText="`${$t('ctx.import.segmentation__export-action')}`"
        :importInformation="importInformation"
        :downloadCSV="downloadCSV"
      ></c-import-information>
    </c-import-base>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { CImportBase, CImportInformation } from '@invivodf/common/src/contexts/parameters'
import { segmentService } from '../../services'

const csvFileProperties = {
  name: 'segments.csv',
  full_path: '/assets/csv/segments.csv',
}
export default {
  name: 'CImportSegments',
  components: {
    CImportBase,
    CImportInformation,
  },
  data() {
    return {
      csvProperties: csvFileProperties,
      segmentService,
      importInformation: {
        count: null,
        lastImportAt: null,
      },
    }
  },
  computed: {
    ...mapGetters(['cooperativeId', 'cooperative']),
  },
  methods: {
    downloadCSV() {
      return segmentService.download(this.cooperativeId, this.cooperative.name)
    },
  },
}
</script>
